<a class="help-card" [routerLink]="'/help/' + helpCardData()?._id || ''">
  <div class="help-card__cover-container">
    <!-- video cover -->
    <img
      class="help-card__cover"
      [ngSrc]="
        helpCardData()?.cover?.cropped_url?.toLowerCase() ||
          helpCardData()?.cover?.url | imageSource
      "
      [width]="264"
      [height]="166"
      [alt]="(helpCardData()?.topic?.title | translateData) || ''" />
    @if (helpCardData()?.video_duration) {
      <div class="help-card__video-duration">
        <!-- video time -->
        <span>
          {{ helpCardData()?.video_duration | date: 'mm:ss' }}
        </span>
      </div>
    }
  </div>

  <!-- title of the help card -->
  <div class="help-card__content">
    <!-- help title -->
    <h3 class="help-card__title">
      {{ helpCardData()?.topic?.title | translateData }}
    </h3>
    <!-- help description -->
    <p class="help-card__description">
      {{ (helpCardData()?.description | translateData)?.slice(0, 70) }}...
    </p>
  </div>
</a>
